import { ParameterGroupDto } from 'src/store/parametergroups/parametergroup';
import { ArrayUtils } from 'src/utils/array';
import {
  ParameterGroupAction,
  ParameterGroupTypes
} from './parametergroups.actions';

export type ParameterGroupsState = Readonly<{
  parameterGroups: ParameterGroupDto[];
  errors: any;
}>;

const initialState: ParameterGroupsState = {
  parameterGroups: [],
  errors: null
};

const parameterGroupsReducer = (
  state: ParameterGroupsState = initialState,
  action: ParameterGroupAction
) => {
  switch (action.type) {
    case ParameterGroupTypes.FetchAll:
      return { ...state, parameterGroups: action.parameterGroups };
    case ParameterGroupTypes.Add:
      return {
        ...state,
        parameterGroups: [...state.parameterGroups, action.parameterGroup]
      };
    case ParameterGroupTypes.Update:
      return {
        ...state,
        parameterGroups: ArrayUtils.updateListById(
          state.parameterGroups,
          action.parameterGroup
        )
      };
    case ParameterGroupTypes.Delete:
      return {
        ...state,
        parameterGroup: null,
        parameterGroups: ArrayUtils.deleteFromListById(
          state.parameterGroups,
          action.parameterGroup
        )
      };
    case ParameterGroupTypes.Failure:
      return { ...state, errors: action.errors };
    default:
      return state;
  }
};

export default parameterGroupsReducer;
